<template>
  <div class="modal_confirm">
    <div class="title">
      <span> {{ text }} </span>
    </div>
    <div class="text-center">
      <button class="btn btn-info btn-fill btn-wd marginButton" @click.prevent="confirm">
        {{ translate('yes') }}
      </button>

      <button class="btn btn-danger btn-fill btn-wd marginButton" @click.prevent="cancel">
        {{ translate('no') }}
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: "ModalConfirm",
  props: ['text'],

  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm')
    },
  }
}
</script>

<style lang='scss' scoped>
.modal_confirm{
  padding: 10px 0;
  .title{
    text-align: center;
  }
}

</style>
